/*Spanish (Spain, International Sort) locale*/
const es = {
	groupDelimiter:".",
	groupSize:3,
	decimalDelimiter:",",
	decimalSize:2,
	dateFormat:"%d/%n/%Y",
	timeFormat:"%G:%i",
	longDateFormat:"%d %F %Y",
	fullDateFormat:"%d %F %Y %G:%i",
	am:null,
	pm:null,
	price:"{obj} €",
	priceSettings:{
		groupDelimiter:".",
		groupSize:3,
		decimalDelimiter:",",
		decimalSize:2
	},
	calendar:{
		monthFull:["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],
		monthShort:["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"],
		dayFull:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"],
		dayShort:["dom","lun","mar","mié","jue","vie","sáb"],
		hours: "Horas",
		minutes: "Minutos",
		done:"Listo",
		clear: "Reinicio",
		today: "Hoy"
	},

	dataExport:{
		page:"Página",
		of:"de"
	},
	PDFviewer:{
		of:"de",
		automaticZoom:"Zoom automático",
		actualSize:"Tamaño real",
		pageFit:"Tamaño de página",
		pageWidth:"Ancho de página",
		pageHeight:"Altura de la página",
		enterPassword:"Introduzca la contraseña",
		passwordError:"Contraseña incorrecta"
	},
	aria:{
		calendar:"Сalendario",
		increaseValue:"Aumentar el valor",
		decreaseValue:"Disminuye el valor",
		navMonth:["Mes anterior", "Próximo mes"],
		navYear:["Año anterior", "Próximo año"],
		navDecade:["Década anterior", "Próxima década"],
		dateFormat:"%d %F %Y",
		monthFormat:"%F %Y",
		yearFormat:"%Y",
		hourFormat:"Horas: %G",
		minuteFormat:"Minutos: %i",
		removeItem:"Retire el elemento",
		pages:["Primera página", "Pagina anterior", "Siguiente página", "Última página"],
		page:"Página",
		headermenu:"Menú de títulos",
		openGroup:"Grupo de columnas abiertas",
		closeGroup:"Primer grupo de columnas",
		closeTab:"Cerrar tab",
		showTabs:"Mostrar más tabs",
		resetTreeMap:"Volver a la vista original",
		navTreeMap:"Elevar a mismo nivel",
		nextTab:"Siguiente tab",
		prevTab:"Tab anterior",
		multitextSection:"Añadir elemento",
		multitextextraSection:"Retire el elemento",
		showChart:"Espectáculo chart",
		hideChart:"Esconder chart",
		resizeChart:"Cambiar el tamaño el chart"
	},
	richtext:{
		underline: "Subrayar",
		bold: "Negrita",
		italic: "Itálico"
	},
	combo:{
		select:"Seleccionar",
		selectAll:"Seleccionar todo",
		unselectAll:"Deselecciona todo"
	},
	message:{
		ok:"OK",
		cancel:"Cancelar"
	},
	comments:{
		send: "Enviar",
		confirmMessage: "El comentario será eliminado. Estás seguro?",
		edit: "Corregir",
		remove: "Suprimir",
		placeholder: "Escriba aquí..",
		moreComments:"Más comentarios"
	},
	filter:{
		less: "menos",
		lessOrEqual: "menor o igual",
		greater: "mayor",
		greaterOrEqual: "mayor o igual",
		contains: "contiene",
		notContains: "not contiene",
		equal: "igual",
		notEqual: "no es igual"
	}
};

export default es;